import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".style-module_buttonTertiary__8NI8O {\n}\n\n.style-module_buttonTertiaryContentWrapper__-r2sS {\n}\n\n.style-module_buttonTertiary__8NI8O:not(:disabled):hover .style-module_buttonTertiaryContentWrapper__-r2sS::after {\n  transform: scaleY(3);\n}\n\n.style-module_buttonTertiary__8NI8O:not(:disabled):active .style-module_buttonTertiaryContentWrapper__-r2sS::after {\n  transform: scaleY(5);\n}\n";
var style = {"buttonTertiary":"style-module_buttonTertiary__8NI8O","buttonTertiaryContentWrapper":"style-module_buttonTertiaryContentWrapper__-r2sS"};
styleInject(css_248z);

export { style as default };
